import { render, staticRenderFns } from "./main-recent.vue?vue&type=template&id=62f457e3&scoped=true"
import script from "./main-recent.vue?vue&type=script&lang=js"
export * from "./main-recent.vue?vue&type=script&lang=js"
import style0 from "./main-recent.vue?vue&type=style&index=0&id=62f457e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f457e3",
  null
  
)

export default component.exports